export default function HelpAssetsItemsService(gettext) {

	'ngInject';

	this.getModule = function () {

		var module = {
			"id": "assets", //change to equipment from asset because we are using the state as the id for redirecting to selected pages' help 
			"name": gettext("Assets"),
			"description": gettext("The Assets area is used to view asset details and data."),
			"icon": "fas fa-question-circle",
			"priority": 2,
			"items": [{
				"orderid": 2.1,
				"itemid": "assetslist",
				"helpitemid": "assets",
				"name": gettext("View Assets"),
				"templateUrl": "assets/assets.html"
			},
			{
				"orderid": 2.2,
				"itemid": "assetsdetail",
				"helpitemid": "assets",
				"name": gettext("Asset Details"),
				"templateUrl": "assets/assets.details.html"
			}
			]
		};

		return module;
	};
}